import React from 'react';
import { achievements, featuredAchievement, metricAchievements } from '../data/achievements';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
export function Achievements() {
  return <section aria-labelledby="achievements-title" className="bg-paper py-20 md:py-28" data-id="element-139" data-mp="3j5830oa5qn5h">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-140" data-mp="3e4kb80e3u2a7">
        <SectionHeading id="achievements-title" label="05 · Career achievements" title="Transformations led, markets opened." data-id="element-141" data-mp="2qdws0iyqnq8c" />

        <Reveal className="mt-14" data-id="element-142" data-mp="2me636ksrvk6g">
          <article className="grid gap-10 rounded-sm bg-ink p-8 text-paper md:p-12 lg:grid-cols-12 lg:gap-14" data-id="element-143" data-mp="2mf7jb3onawv1">
            <div className="lg:col-span-6" data-id="element-144" data-mp="2vdj60ume5ai7">
              <p className="text-sm text-bronze-light" data-id="element-145" data-mp="2vcrkydqf6v66">
                {featuredAchievement.organization} · {featuredAchievement.period}
              </p>
              <h3 className="mt-4 font-serif text-3xl leading-tight md:text-4xl" data-id="element-146" data-mp="ankc3p26l1yl">{featuredAchievement.title}</h3>
              <p className="mt-6 text-base leading-relaxed text-slate-light" data-id="element-147" data-mp="hx6l3ugwf5v6">{featuredAchievement.description}</p>
            </div>
            <ul className="divide-y divide-line-dark border-y border-line-dark lg:col-span-6 lg:self-center" data-id="element-148" data-mp="mugf7nf8g5pc">
              {featuredAchievement.outcomes.map(outcome => <li key={outcome} className="flex gap-4 py-4 text-base text-paper" data-id="element-149" data-mp="wu7ctxz3b0tn">
                  <span className="mt-3 h-px w-4 shrink-0 bg-bronze-light" aria-hidden="true" data-id="element-150" data-mp="3vbtbzsv7zs86" />
                  {outcome}
                </li>)}
            </ul>
          </article>
        </Reveal>

        <div className="mt-6 grid gap-6 md:grid-cols-2" data-id="element-151" data-mp="94397qlwj12n">
          {metricAchievements.map((a, i) => <Reveal key={a.title} delay={i * 0.05} data-id="element-152" data-mp="dvbnazy6fam5" data-mpi={i}>
              <article className="flex h-full gap-8 rounded-sm border border-line p-8" data-id="element-153" data-mp="dwwfwk0xkjhd">
                <div className="shrink-0" data-id="element-154" data-mp="3cizbg3ycg2nh">
                  <p className="font-serif text-6xl leading-none text-bronze" data-id="element-155" data-mp="3hjn2gpmkojhp">{a.metric?.value}</p>
                  <p className="mt-2 max-w-[7rem] text-xs text-slate-text" data-id="element-156" data-mp="39iyxqienf5jh">{a.metric?.label}</p>
                </div>
                <div data-id="element-157" data-mp="34jcjq6qzxl9m">
                  <p className="text-sm text-slate-text" data-id="element-158" data-mp="34k41oero7khf">
                    {a.organization} · <span className="tabular-nums" data-id="element-159" data-mp="3j88pfx5kym72">{a.period}</span>
                  </p>
                  <h3 className="mt-2 font-serif text-2xl leading-snug text-ink" data-id="element-160" data-mp="3e9xflmfacbou">{a.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-text" data-id="element-161" data-mp="2qjtbldy6q9xb">{a.description}</p>
                </div>
              </article>
            </Reveal>)}
        </div>

        <ul className="mt-16 grid gap-x-16 md:grid-cols-2" data-id="element-162" data-mp="30jbs1kevzdkm">
          {achievements.map((a, i) => <li key={a.title} className="border-t border-line" data-id="element-163" data-mp="2vj67eo71arc1" data-mpi={i}>
              <Reveal delay={Math.min(i, 4) * 0.04} className="py-8" data-id="element-164" data-mp="2vm26ifumbm22">
                <p className="text-sm text-bronze" data-id="element-165" data-mp="fr08dfiofqde">
                  {a.organization} · <span className="tabular-nums" data-id="element-166" data-mp="au9vf1265aw7">{a.period}</span>
                </p>
                <h3 className="mt-2 font-serif text-2xl text-ink" data-id="element-167" data-mp="icgasdi22r14">{a.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-slate-text" data-id="element-168" data-mp="nc2qqup9qldm">{a.description}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}